<template>
  <div class="Typeahead">
    <i class="fa fa-spinner fa-spin" v-if="loading"></i>
    <template v-else>
      <i class="fa fa-search" v-show="isEmpty"></i>
      <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
    </template>

    <input type="text"
      class="Typeahead__input"
      placeholder="Search Projects..."
      autocomplete="off"
      v-model="query"
      ref="input"
      spellcheck="false"
      @keydown.down="down"
      @keydown.up="up"
      @keydown.enter="hit"
      @keydown.esc="reset"
      @blur="reset"
      v-debounce:40ms.lock="update" :debounce-events="'input'"/>

    <ul v-show="hasItems">
      <li :key="index" v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
        <span class="name" v-text="item[queryParam]"></span>
        <span class="screen-name" v-text="item.screen_name"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    limit: 10,
    minChars: 3,
    items: [],
    query: '',
    current: -1,
    loading: false,
    selectFirst: false
  }),
  props: {
    src: {
      type: String
    },
    queryParam: {
      type: String,
      default: 'name'
    }
  },
  mounted () {
    this.$refs.input.focus()
  },
  computed: {
    hasItems () {
      return this.items.length > 0
    },

    isEmpty () {
      return !this.query
    },

    isDirty () {
      return !!this.query
    }
  },
  methods: {
    ...mapActions([
      'setModalSearchProjectsVisible'
    ]),
    update () {
      this.cancel()

      if (!this.query) {
        return this.reset()
      }

      if (this.minChars && this.query.length < this.minChars) {
        return
      }

      this.loading = true

      this.fetch().then((response) => {
        if (response && this.query) {
          let data = response.data
          data = this.prepareResponseData ? this.prepareResponseData(data) : data
          this.items = this.limit ? data.slice(0, this.limit) : data
          this.current = -1
          this.loading = false

          if (this.selectFirst) {
            this.down()
          }
        }
      })
    },

    async fetch () {
      const src = `${this.src}?param=${this.query},${this.queryParam}`
      try {
        let request = await axios.get(src)
        return request.data
      } catch (error) {
        console.log(error.message)
      }
    },

    cancel () {
      // used to 'cancel' previous searches
    },

    reset () {
      this.items = []
      this.query = ''
      this.loading = false
    },

    setActive (index) {
      this.current = index
    },

    activeClass (index) {
      return {
        active: this.current === index
      }
    },

    hit () {
      if (this.current !== -1) {
        this.onHit(this.items[this.current])
      }
    },

    up () {
      if (this.current > 0) {
        this.current--
      } else if (this.current === -1) {
        this.current = this.items.length - 1
      } else {
        this.current = -1
      }
    },

    down () {
      if (this.current < this.items.length - 1) {
        this.current++
      } else {
        this.current = -1
      }
    },

    onHit (item) {
      this.$emit('getData', item)
      this.setModalSearchProjectsVisible(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.Typeahead {
  margin-left: 15px;
}

.Typeahead__input {
  width: 100%;
  font-size: 1.5rem;
  font-weight: 300;
  border: none;
  background: transparent;
  box-sizing: border-box;
  color: #070207;
  &::placeholder {
    color: #2c3e50;
  }
  &::selection {
    background-color: rgba(var(--primary), 1);
    color: white;
  }
}

.fa-times {
  cursor: pointer;
}

i {
  float: right;
  position: relative;
  top: 30px;
  right: 29px;
  opacity: 0.4;
}

ul {
  // position: absolute;
  padding: 0;
  margin-top: 8px;
  left: 0;
  min-width: 100%;
  list-style: none;
  border-radius: 4px;
  // box-shadow: 0 5px 10px 0 rgba(0,0,0, 0.10);
  z-index: 1000;
  transition: 0.1s all ease-in-out;
}

li {
  background: none;
  padding: 10px  16px;
  // border-bottom: 1px solid #ccc;
  cursor: pointer;
  transition: 0.1s all ease-in-out;
}

li:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

li:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: 0;
}

span {
  display: block;
  color: rgb(101, 104, 116);
}

// .active {
  // background-color: #797f85;
// }

.active span {
  color: white;
}

.name {
  font-weight: 700;
  font-size: 18px;
}

.screen-name {
  font-style: italic;
}

@media only screen and (min-width: 1930px) {
  .Typeahead__input {
    font-size: 3vw;
  }
  .name {
    font-size: 1.5vw !important;
  }
}
</style>
